export default __webpack_public_path__ + "static/media/lab-icon-lock.d7ed6128.svg";